import script from "./BattleDetailedReportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleDetailedReportModal.vue?vue&type=script&setup=true&lang=js"

import "./BattleDetailedReportModal.vue?vue&type=style&index=0&id=bb1b1e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1b1e36"]])

export default __exports__